import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Resource } from '../models/resource.model';
import { ApiResponse } from '../models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class ResourceService {
  private apiUrl = `${environment.apiUrl}/resources`;

  constructor(private http: HttpClient) {}

  /**
   * Get all resources for an enrollment
   */
  getResourcesByEnrollment(enrollmentId: number): Observable<ApiResponse<Resource[]>> {
    return this.http.get<ApiResponse<Resource[]>>(`${this.apiUrl}/enrollment/${enrollmentId}`);
  }

  /**
   * Get resource by ID
   */
  getResourceById(id: number): Observable<ApiResponse<Resource>> {
    return this.http.get<ApiResponse<Resource>>(`${this.apiUrl}/${id}`);
  }

  /**
   * Create new resource
   */
  createResource(data: FormData): Observable<ApiResponse<Resource>> {
    return this.http.post<ApiResponse<Resource>>(this.apiUrl, data);
  }

  /**
   * Update resource
   */
  updateResource(id: number, data: FormData): Observable<ApiResponse<Resource>> {
    return this.http.put<ApiResponse<Resource>>(`${this.apiUrl}/${id}`, data);
  }

  /**
   * Delete resource
   */
  deleteResource(id: number): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/${id}`);
  }

  /**
   * Get resource response
   */
  getResourceResponse(id: number): Observable<ApiResponse<Resource>> {
    return this.http.get<ApiResponse<Resource>>(`${this.apiUrl}/${id}/response`);
  }
}
